import { Component, OnInit ,Input} from '@angular/core';

@Component({
  selector: 'app-simple',
  templateUrl: './simple.component.html',
  styleUrls: ['./simple.component.scss']
})
export class SimpleComponent implements OnInit {

  stremprunt =`
  " Feminisme et pop culture ; Jennifer Padjemi ; 20/01/2021 ; 20/03/2021 "
  " Design Pattern ; BUFJ ; 15/02/2021 ; 15/04/2021 "
  " Gardez l'oeil ouvert - Tome 2 ; Victoria Charlton ; 10/03/2021 ; 10/05/2021 "
  `
  tab: any;
  str: string = `
  "Maurice ; Phillipe ; 0478963584 ; phillipem@uga.fr ; BMDA201 "
  "Brassens ; Georges ; 0611734938 ; brassensgoerg@uga.fr ; BMDA101 "
  "Dupont ; Guillaume ; 0649283478 ; guiguidup@uga.fr ; LIG203 "
  "Delabatte ; Fernand ; 0489345826 ; fernanddel@uga.fr ; LIG308 "
  "Flantier ; Noel ; 0498342685 ; flantierno@uga.fr ; LIG101 "
  "Armand ; Herve ; 0746851247 ; armandher@uga.fr ; BMDE007 "
  "Labousille ; Joe ; 0682131348 ; labousijo@uga.fr ; LIG202 "
  `;


  @Input() appareilName: string;
  name1: string = "simpleEmprunt";
  name2: string = "simpleContact";
  ind: number = 0;

  constructor() {
    this.appareilName = "";
   }

  ngOnInit(): void {
    this.tab = this.chooseTab();
  }

  chooseTab() {
    if (this.appareilName == "emprunts") {
      console.log(this.parseE(this.stremprunt));
      return this.parseE(this.stremprunt);
    }
    else {
      console.log("parseM");
      return this.parse(this.str);
    }
  }

  setId(event :any) {
    console.log(event);
    console.log(event.target.id);
    this.ind = event.target.id;

  }

  sendContact(ind : number) {
    return [this.tab[ind].nom, this.tab[ind].prenom, this.tab[ind].tel, this.tab[ind].mail, this.tab[ind].bureau];
  }

  sendEmprunt(ind : number) {
    return [this.tab[ind].titre, this.tab[ind].auteur, this.tab[ind].dateEmprunt, this.tab[ind].dateFinEmprunt];
  }

  parse(str: string): INFO[] {

    const L: INFO [] = str.trim().split("\n").map(s => s.trim()).filter(s => s!=="")

                 .map( s => s.split(";").map( s => s.slice(1, -1) ) )

                 .map( ([n, p,t,m,b]) => ({

                     nom: n,

                   prenom: p,
                     
                   tel: t,
                   
                   mail: m,
                   
                   bureau:b

                 }));

    return L;

  }

  parseE(str: string): EMP[] {

    const L: EMP[] = str.trim().split("\n").map(s => s.trim()).filter(s => s !== "")

      .map(s => s.split(";").map(s => s.slice(1, -1)))

      .map(([t,a,de,df]) => ({

        titre: t,
         
        auteur: a,

        dateEmprunt: de,
        
        dateFinEmprunt:df,

                 }));

    return L;

  }

}

interface INFO {

  nom: string;

  prenom: string;

  tel: string;

  mail: string;

  bureau: string;
}

interface EMP{

  titre: string;

  auteur: string;

  dateEmprunt: string;

  dateFinEmprunt: string;

}